import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shell", "label", "footer"]

  connect() {
    this.boundFullscreenChange = this.handleFullscreenChange.bind(this)
    document.addEventListener("fullscreenchange", this.boundFullscreenChange)
  }

  disconnect() {
    document.removeEventListener("fullscreenchange", this.boundFullscreenChange)
    this.teardownFallback()
  }

  async toggle(event) {
    event.preventDefault()

    if (document.fullscreenEnabled && this.hasShellTarget) {
      if (document.fullscreenElement === this.shellTarget) {
        await document.exitFullscreen()
      } else {
        await this.shellTarget.requestFullscreen()
      }
      return
    }

    const active = !this.shellTarget.classList.contains("documents-studio-active")
    this.applyStudioState(active)
    this.syncUi(active)
  }

  handleFullscreenChange() {
    const active = document.fullscreenElement === this.shellTarget
    this.applyStudioState(active)
    this.syncUi(active)
  }

  syncUi(active) {
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = active ? "Exit Studio" : "Studio Mode"
    }

    if (this.hasFooterTarget) {
      this.footerTarget.classList.toggle("d-none", active)
    }
  }

  teardownFallback() {
    this.applyStudioState(false)
  }

  applyStudioState(active) {
    if (this.hasShellTarget) {
      this.shellTarget.classList.toggle("documents-studio-active", active)
    }
    this.element.classList.toggle("documents-studio-page-active", active)
    document.documentElement.classList.toggle("documents-studio-html-active", active)
    document.body.classList.toggle("documents-studio-body-active", active)
  }
}
